module.exports = __webpack_public_path__ + "img/storage15.5f28331d.jpg";